









































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import FieldImg from '@/app/components/Field/FieldImg.vue'
/* module */
import { fieldDetailsData } from '@/app/model/store/domain/types'
import Session from '@/app/module/session'
import { routerPath, plantingType } from '@/app/model/store/domain/const'
import DetailsContent from '../FieldDetails/DetailsContent.vue'
import Local from '@/app/module/local'
import DateClass from '@/app/module/date'

@Component({
  components: {
    Loading,
    FieldImg
  }
})
export default class FieldListItem extends Vue {
  /* アイコン */
  private waterTemperatureIcon: string = require('@/assets/icon/ico_watertemperature2.png')
  private waterLevelIcon: string = require('@/assets/icon/ico_waterlevel2.png')
  /* クラス */
  private isActiveClass: boolean = false
  private isModalActiveClass: boolean = false
  /* 表示切り替え */
  private showToDetails: boolean = true
  private showFieldItem: boolean = false
  private showNodata: boolean = false
  private showLackData: boolean = false
  private showLoading: boolean = false
  /* データ */
  private detailsData: any = {
    field_id: 0,
    field_lng: '',
    field_lat: '',
    planting_id: 0,
    field_name: '-',
    variety_id: 0,
    variety_name: '-',
    harvest_forecast_days: 0,
    grade_gole: 1,
    growth_stage_name: '-',
    worker_name: '-',
    image_path: require('@/assets/icon/ico_cultivation2.png'),
    max_intergration_temperature: 0,
    intergration_temperature: 0,
    water_temperature: 0,
    water_level: 0,
    risk: {
      sickness: false,
      weeds: false,
      pest: false,
      high_temperature: false,
      lodging: false
    }
  }
  private fieldId: string = ''
  private memori: number[] = []
  private oneMemoriWidth: number = 0
  private oneWidthTemperature:number = 0
  private maxIntegrationTemperature: number = 2300
  private linkTo: string = ''
  private renderImg: boolean = false
  private gradeList: Array<{[key:string]: string|number}> = []

  private get fieldSortFlag (): boolean {
    return this.$store.state.fieldState.fieldSortFlag
  }
  @Watch('fieldSortFlag')
  getFieldSortFlag (flag: boolean) {
    // リストの並び替えが終わってたらitemを再生成
    if (!flag) {
      this.linkTo = '/field/' + this.item.fieldId
      // 選択中の圃場にactiveクラス追加
      let id = this.$store.state.fieldChoiceState.id
      if (this.item.fieldId === parseInt(id)) {
        this.isActiveClass = true
      } else {
        this.isActiveClass = false
      }
      this.getFieldDetailsData()
    }
  }

  @Prop() private item!:any
  @Prop() private accordionId!: number
  @Prop() private flag!: boolean // アコーディオン開閉フラグ
  @Prop() private displayFlag!: boolean // 圃場一覧画面かモーダルかのフラグ
  @Prop() private accordionChangeFlag!: boolean
  /* computed */
  private get fieldChoiceState (): number {
    return this.$store.state.fieldChoiceState.id
  }
  private get modalFieldChoiceState (): number {
    return this.$store.state.fieldChoiceState.modalId
  }
  private get detailsDataFlag (): boolean {
    return this.$store.state.setFlagState.fieldDetailsDataFlag
  }
  private get modalMetailsDataFlag (): boolean {
    return this.$store.state.setFlagState.fieldModalDetailsFlag
  }
  private get accordionFlag (): boolean {
    return this.accordionChangeFlag
  }
  private get openGraphSettingFlag (): boolean {
    return this.$store.state.setFlagState.openSettingModalFlag
  }
  @Watch('fieldChoiceState')
  onIdChange (newValue: string) {
    this.fieldId = newValue
    if (this.displayFlag) {
      Session.setChoiceFieldId(String(newValue))
      if (this.item.fieldId === parseInt(this.fieldId)) {
        this.isActiveClass = true
      } else {
        this.isActiveClass = false
      }
    } else {
      if (this.item.fieldId === parseInt(this.fieldId)) {
        this.isModalActiveClass = true
      } else {
        this.isModalActiveClass = false
      }
    }
  }
  @Watch('modalFieldChoiceState')
  ooModalIdChange (newValue: string) {
    if (newValue === this.item.fieldId) {
      if (this.detailsData.planting_id !== 0) {
        this.isModalActiveClass = true
      }
    } else {
      this.isModalActiveClass = false
    }
  }
  @Watch('detailsDataFlag')
  getDetailsDataFlag (flag: boolean) {
    if (flag) {
      this.linkTo = '/field/' + this.item.fieldId
      this.getFieldDetailsData()
    }
  }
  @Watch('modalMetailsDataFlag')
  getModalDetailsDataFlag (flag: boolean) {
    if (flag) {
      this.getModalDetailsData()
      this.showLoading = false
    }
  }
  @Watch('accordionFlag')
  getAccordionFlag () {
    this.progressMemori()
  }
  @Watch('openGraphSettingFlag')
  getOpenSettingModalFlag (flag: boolean) {
    if (flag) {
      this.progressMemori()
    }
  }

  created () {
    // 等級の配列を作成
    const constantValue = JSON.parse(Local.getConstantValue()!)
    this.gradeList = constantValue.grades

    // 画面かモーダルかの判定
    if (!this.displayFlag) {
      this.showToDetails = false
      this.showLoading = true
      this.getModalDetailsData()
      return
    }

    if (this.$store.state.setFlagState.fieldDetailsDataFlag) {
      this.linkTo = '/field/' + this.item.fieldId
      this.getFieldDetailsData()
    } else {
      // 詳細データがない場合
      this.linkTo = '/field/' + this.item.fieldId
      this.$emit('show-loading')
    }
  }

  mounted () {
    // 圃場詳細 グラフ表示項目保持で比較圃場選択されていた場合選択表示
    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (this.$route.name === '圃場詳細' && settingData !== null && settingData.tab === '3') {
      if (settingData.fieldId === this.item.fieldId) {
        this.isModalActiveClass = true
      }
    }

    window.addEventListener('resize', this.progressMemori)
  }

  private getGradeName (id: number) {
    for (let i in this.gradeList) {
      if (id === this.gradeList[i].grade_id) {
        return this.gradeList[i].grade_name
      }
    }
    return '-等級'
  }

  private displayPlantingType (type: number) {
    if (type === plantingType.PLANTING_TYPE_SOWING) {
      return '播種'
    } else {
      return '移植'
    }
  }

  private displayValue (value: string|number) {
    return value !== null && value !== undefined ? value : '-'
  }

  /* 詳細データ取得 */
  private async getFieldDetailsData () {
    let detailsContent: any = await Session.getFieldDetailsData(String(this.accordionId))!
    detailsContent = JSON.parse(detailsContent)

    this.showFieldItem = true
    // timestamp削除
    if (detailsContent !== null) {
      delete detailsContent[0]
    }

    if (this.item.fieldId !== 0) {
      for (var i in detailsContent) {
        let result = {}
        if (this.item.fieldId === detailsContent[i].field_id) {
          // 欠損データがある場合
          if (detailsContent[i].max_intergration_temperature === 0) {
            this.showLackData = true
            this.showNodata = false
          } else {
            this.showLackData = false
          }

          result = detailsContent[i]
          this.maxIntegrationTemperature = detailsContent[i].max_intergration_temperature
          this.detailsData = result
          this.showNodata = false
          this.renderImg = true

          this.judgmentWaterTemperatureIcon()
          this.judgmentWaterLevelIcon()
          this.progressMemori()
        }

        /* 圃場一覧取得後、圃場詳細取得前に圃場が削除された時用にundifined */
        if (this.detailsData.planting_id === undefined || this.detailsData.planting_id === 0) {
          this.showLackData = false
          this.showNodata = true
          // 初期値に戻す
          this.detailsData = {
            field_id: 0,
            field_lng: '',
            field_lat: '',
            planting_id: 0,
            field_name: detailsContent[i].field_name,
            variety_id: 0,
            variety_name: '-',
            harvest_forecast_days: 0,
            grade_gole: 1,
            growth_stage_name: '-',
            worker_name: '-',
            image_path: require('@/assets/icon/ico_cultivation2.png'),
            max_intergration_temperature: 0,
            intergration_temperature: 0,
            water_temperature: 0,
            water_level: 0,
            risk: {
              sickness: false,
              weeds: false,
              pest: false,
              high_temperature: false,
              lodging: false
            }
          }
        }
      }
      this.$emit('show-loading')
    } else {
      this.showNodata = true
      // 初期値に戻す
      this.detailsData = {
        field_id: 0,
        field_lng: '',
        field_lat: '',
        planting_id: 0,
        field_name: '-',
        variety_id: 0,
        variety_name: '-',
        harvest_forecast_days: 0,
        grade_gole: 1,
        growth_stage_name: '-',
        worker_name: '-',
        image_path: require('@/assets/icon/ico_cultivation2.png'),
        max_intergration_temperature: 0,
        intergration_temperature: 0,
        water_temperature: 0,
        water_level: 0,
        risk: {
          sickness: false,
          weeds: false,
          pest: false,
          high_temperature: false,
          lodging: false
        }
      }
      this.showFieldItem = true
      this.$emit('show-loading')
      return
    }

    /* フラグリセット */
    this.$store.commit('fieldState/setFieldSortFlag', true)
    this.$store.commit('setFlagState/setFieldDetailsDataFlag', false)
  }

  /* モーダルの詳細データを取得 */
  private async getModalDetailsData () {
    let detailsContent: any = await Session.getModalFieldDetailsData(String(this.accordionId))!
    detailsContent = JSON.parse(detailsContent)

    this.showFieldItem = true
    // timestamp削除
    if (detailsContent !== null) {
      delete detailsContent[0]
    }

    if (this.item.fieldId !== 0) {
      for (var i in detailsContent) {
        let result = {}
        if (this.item.fieldId === detailsContent[i].field_id) {
          // 欠損データがある場合
          if (detailsContent[i].max_intergration_temperature === 0) {
            this.showLackData = true
            this.showNodata = false
          }

          result = detailsContent[i]
          this.maxIntegrationTemperature = detailsContent[i].max_intergration_temperature
          this.detailsData = result
          this.showNodata = false
          this.renderImg = true

          this.judgmentWaterTemperatureIcon()
          this.judgmentWaterLevelIcon()
          this.progressMemori()
        }

        if (detailsContent[i].planting_id === undefined) {
          this.showNodata = true
          // 初期値に戻す
          this.detailsData = {
            field_id: 0,
            field_lng: '',
            field_lat: '',
            planting_id: 0,
            field_name: '-',
            variety_id: 0,
            variety_name: '-',
            harvest_forecast_days: 0,
            grade_gole: 1,
            growth_stage_name: '-',
            worker_name: '-',
            image_path: require('@/assets/icon/ico_cultivation2.png'),
            max_intergration_temperature: 0,
            intergration_temperature: 0,
            water_temperature: 0,
            water_level: 0,
            risk: {
              sickness: false,
              weeds: false,
              pest: false,
              high_temperature: false,
              lodging: false
            }
          }
        }
      }
      this.$emit('show-loading')
    } else {
      this.showNodata = true
      // 初期値に戻す
      this.detailsData = {
        field_id: 0,
        field_lng: '',
        field_lat: '',
        planting_id: 0,
        field_name: '-',
        variety_id: 0,
        variety_name: '-',
        harvest_forecast_days: 0,
        grade_gole: 1,
        growth_stage_name: '-',
        worker_name: '-',
        image_path: require('@/assets/icon/ico_cultivation2.png'),
        max_intergration_temperature: 0,
        intergration_temperature: 0,
        water_temperature: 0,
        water_level: 0,
        risk: {
          sickness: false,
          weeds: false,
          pest: false,
          high_temperature: false,
          lodging: false
        }
      }
      this.showFieldItem = true
      this.$emit('show-loading')
    }

    if (detailsContent !== null) {
      this.showLoading = false
    }

    /* フラグリセット */
    this.$store.commit('fieldState/setFieldSortFlag', true)
    this.$store.commit('setFlagState/setFieldModalDetailsFlag', false)
  }

  /* プログレスバーメモリ */
  private progressMemori () {
    const targetWidth:any = this.$refs.getBarWidth
    if (targetWidth !== undefined) {
      this.oneWidthTemperature = this.maxIntegrationTemperature / targetWidth.clientWidth
      this.oneMemoriWidth = 500 / this.oneWidthTemperature
      this.memori = []

      for (var i = 500; i < this.maxIntegrationTemperature; i += 500) {
        this.memori.push(i)
      }
    }
  }

  /* 水温アイコン */
  judgmentWaterTemperatureIcon () {
    if (this.detailsData.water_temp_lower_limit === null && this.detailsData.water_temp_upper_limit === null) {
      // 閾値がnullの場合は正常アイコンを表示する
      this.waterTemperatureIcon = require('@/assets/icon/ico_watertemperature2.png')
    } else if (this.detailsData.water_temperature < this.detailsData.water_temp_lower_limit) {
      // 下限未満
      this.waterTemperatureIcon = require('@/assets/icon/ico_watertemperature1.png')
    } else if (this.detailsData.water_temperature > this.detailsData.water_temp_upper_limit) {
      // 上限以上
      this.waterTemperatureIcon = require('@/assets/icon/ico_watertemperature3.png')
    } else {
      // 下限以上上限以下
      this.waterTemperatureIcon = require('@/assets/icon/ico_watertemperature2.png')
    }
  }

  /* 水位アイコン */
  judgmentWaterLevelIcon () {
    if (this.detailsData.water_level_lower_limit === null && this.detailsData.water_level_upper_limit === null) {
      // 閾値がnullの場合は正常アイコンを表示する
      this.waterLevelIcon = require('@/assets/icon/ico_waterlevel2.png')
    } else if (this.detailsData.water_level < this.detailsData.water_level_lower_limit) {
      // 下限未満
      this.waterLevelIcon = require('@/assets/icon/ico_waterlevel1.png')
    } else if (this.detailsData.water_level > this.detailsData.water_level_upper_limit) {
      // 上限以上
      this.waterLevelIcon = require('@/assets/icon/ico_waterlevel3.png')
    } else {
      // 下限以上上限以下
      this.waterLevelIcon = require('@/assets/icon/ico_waterlevel2.png')
    }
  }

  /* リストをクリックした際にstate管理する */
  private setChoiceField (id: number) {
    if (!this.displayFlag) {
      if (id !== this.$store.state.fieldChoiceState.modalId) {
        this.$store.commit('fieldChoiceState/setChoosingModalFieldId', id)
        this.$store.commit('fieldChoiceState/setIsScroll', false)
        this.$store.commit('fieldChoiceState/setModalPlantingId', this.detailsData.planting_id)
      } else {
        this.$store.commit('fieldChoiceState/setClickModalFlag', true)
      }
    } else {
      this.isActiveClass = true
      if (id !== this.$store.state.fieldChoiceState.id) {
        Session.setChoiceFieldId(String(id))
        this.$store.commit('fieldChoiceState/setChoosingFieldId', id)
        this.$store.commit('fieldChoiceState/setIsScroll', false)
        this.$store.commit('fieldChoiceState/setChoosingFieldData',
          {
            fieldId: this.item.fieldId,
            fieldName: this.item.fieldName
          }
        )
      } else {
        this.$store.commit('fieldChoiceState/setClickFlag', true)
      }
    }
  }

  private displayHarvestLimit (limitDay: number) {
    return DateClass.displayHarvestLimit(limitDay)
  }

  private displayHarvestLimitDay (limitDay: number) {
    return DateClass.displayHarvestLimitDay(limitDay)
  }

  private displayHarvestDay (limitDay: number, date: string) {
    return DateClass.displayHarvestDay(limitDay, date)
  }
}
